// deskKeys — the page shown owns its keys: the canvas's single-letter tools
// (studioTools.ts) never act while focus is inside it, and Esc (unless a
// field or menu inside took it) goes one level up. Plain keys only: a key
// with a modifier is never ours.

export { deskKeyDown };

import type { KeyboardEvent } from "react";

const deskKeyDown =
    (onClose: () => void) =>
    (e: KeyboardEvent<HTMLElement>): void => {
        e.stopPropagation();
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return;
        if (e.key !== "Escape") return;
        // A field keeps its own Esc (cancel an edit, leave a plain "/"), and
        // so does a menu shown above the page (it bubbles here from a portal).
        const from = e.target;
        if (
            from instanceof HTMLElement &&
            (from.isContentEditable ||
                from.closest("input, textarea, select") !== null)
        )
            return;
        if (from instanceof Node && !e.currentTarget.contains(from)) return;
        e.preventDefault();
        onClose();
    };
